import {
  fetchPublicSuburbanV1CreateRealty,
  IPublicSuburbanV1CreateRealtyRequest,
} from '../../repositories/price-estimator/suburban/v1/create-realty';
import { IApplicationContext } from '../../types/applicationContext';
import { createSubmitSuburbanDataMapper } from './mappers';

export const fetchSuburbanData = async (
  parameters: IPublicSuburbanV1CreateRealtyRequest,
  context: IApplicationContext,
) => {
  try {
    const res = await fetchPublicSuburbanV1CreateRealty({
      parameters,
      httpApi: context.httpApi,
      mappers: createSubmitSuburbanDataMapper(),
    });

    if (res instanceof Error) {
      throw res;
    }

    return res;
  } catch (error) {
    context.logger.error(error, { message: 'error in fetchPublicSuburbanV1CreateRealty' });

    throw error;
  }
};
